import { hasRole } from "@data/utility/ability"

/**
 * La route `menu` montre-t-elle la coquille de l'espace élève (`StudentNavigator`) ? Un compte qui
 * porte le rôle d'élève, hors live — un compte aussi tuteur compris : les routes poussées, elles, le
 * gardent sur le legacy (`studentSpaceBridge`). Lu par la bascule de `BottomTabsNavigator` et par
 * l'en-tête de la route, qui s'efface devant celui de la coquille.
 */
export const opensStudentShell = (user, isLiveMode) => hasRole(user, "student") && !isLiveMode
